import React, { Fragment } from 'react';
import { translate } from '../Services/translation';
import Collapsible from './Collapsible';
import ProductCardImage from './ProductCardImage';
import QuantityBuyButton from './ProductPage/QuantityBuyButton';
import StockStatusTag from './StockStatusTag';
const ProductListViewCard = (product) => {
  return (
    <div
      itemScope
      itemType="http://schema.org/Product"
      className="product-list-card"
    >
      <div className="product-list-card__image-wrapper product-list-card__image-wrapper--desktop">
        <ProductCardImage product={product} hideProductTags={true} />
      </div>
      <div className="product-list-card__desktop-right-section">
        <div className="[ product-list-card__header product-list-card__header--desktop ] [ flex-column ]">
          {(product.hasConfigurator || product.otherProductTags.length > 0) && (
            <div style={{ marginBottom: '0.5rem' }}>
              {product.hasConfigurator && (
                <span className="product-tags__tag align-center">
                  {translate('product-image.custom-size')}
                </span>
              )}
              {product.otherProductTags.map((tag) => (
                <span key={product.id + tag} className="product-tags__tag">
                  {tag}
                </span>
              ))}
            </div>
          )}

          <div className="[ product-list-card__name-price ] [ d-flex justify-between ]">
            <div className="d-flex align-center">
              <h3
                itemProp="name"
                className="[ product-list-card__title ] [ header-6 color-grey-900 ]"
              >
                {product.name}
              </h3>
              <span className="[ product-list-card__category ] [ text-small color-grey-500 text-uppercase ]">
                {product.category}
              </span>
            </div>
            {product.lowestPrice && (
              <div
                className={`product-list-card__from-price ${
                  product.price.formattedCampaignPrice &&
                  '[ product-list-card__from-price--has-campaign ] [ align-center ]'
                }`}
              >
                {translate('product-list-card.from-price')}
                {product.price.formattedCampaignPrice
                  ? product.lowestPrice.formattedCampaignPrice
                  : product.lowestPrice.formattedPrice}
                {product.hasCampaignPrice && (
                  <span>{product.lowestPrice.formattedPrice}</span>
                )}
              </div>
            )}
          </div>
          <a
            className="[ product-list-card__read-more ] [ text-medium color-grey-900 text-underline d-flex ]"
            href={product.url}
          >
            {translate('product-list-card.read-more')}
          </a>
        </div>
        <div className="variant-table">
          <div className="text-medium bold color-grey-900">
            {translate('product-card.product')}
          </div>
          <div className="text-medium bold color-grey-900">
            {translate('product-card.stockstatus')}
          </div>
          <div className="text-medium bold color-grey-900">
            {translate('product-card.price')}
          </div>
          <div className="text-medium bold color-grey-900">&nbsp;</div>
          {product.hasConfigurator ? (
            <>
              <div className="[ variant-table__artnr-and-size ] [ d-flex flex-column justify-center ]">
                <span className="[ variant-table__size ] [ text-medium bold lh-1 ]">
                  {translate('product-card.custome-size')}
                </span>
              </div>
              <div className="[ variant-table__stock-status ] [ d-flex align-center justify-start ]">
                <StockStatusTag
                  isInStock={product.variants[0].isInStock}
                  description={product.variants[0].stockStatusDescription}
                  stockStatusType={product.variants[0].stockStatusType}
                />
              </div>
              <div className="[ variant-table__price ] [ d-flex flex-column align-center ]">
                {product.lowestPrice && (
                  <div
                    className={`product-list-card__from-price text-medium bold ${
                      product.lowestPrice.formattedCampaignPrice &&
                      'product-list-card__from-price--has-campaign d-flex'
                    }`}
                    style={{ flexDirection: 'column' }}
                  >
                    {translate('product-list-card.from-price')}
                    {product.lowestPrice.formattedCampaignPrice
                      ? product.lowestPrice.formattedCampaignPrice
                      : product.lowestPrice.formattedPrice}
                    {product.hasCampaignPrice && (
                      <span>{product.lowestPrice.formattedPrice}</span>
                    )}
                  </div>
                )}
              </div>
              <div className="d-flex align-center">
                <a className="buy-button" href={product.url}>
                  {translate('product-card.choose-size-and-buy')}
                </a>
              </div>
            </>
          ) : (
            product.variants?.map((variant) => (
              <Fragment key={variant.articleNumber}>
                <div className="[ variant-table__artnr-and-size ] [ d-flex flex-column justify-center ]">
                  <span className="[ variant-table__art-nr ] [ text-small color-grey-500 lh-1 ]">
                    {translate('product-card.art-nr')} {variant.articleNumber}
                  </span>
                  <span className="[ variant-table__size ] [ text-medium bold lh-1 ]">
                    {variant.variantName}
                  </span>
                </div>
                <div className="[ variant-table__stock-status ] [ d-flex align-center justify-start ]">
                  <StockStatusTag
                    stockStatusType={variant.stockStatusType}
                    description={variant.stockStatusDescription}
                  />
                </div>

                <div
                  className={`[ variant-table__price ] [ d-flex flex-column text-medium bold ${
                    variant.price.formattedCampaignPrice &&
                    'product-list-card__from-price--has-campaign'
                  } 
                    ${
                      variant.price.formattedCampaignPrice
                        ? 'align-end'
                        : 'align-center'
                    } ]`}
                >
                  {variant.price.formattedCampaignPrice
                    ? variant.price.formattedCampaignPrice
                    : variant.price.formattedPrice}
                  {variant.price.formattedCampaignPrice && (
                    <span>{variant.price.formattedPrice}</span>
                  )}
                </div>
                <div className="[ d-flex align-center justify-end ]">
                  <QuantityBuyButton
                    selectedVariantArtNumber={variant.articleNumber}
                  />
                </div>
              </Fragment>
            ))
          )}
        </div>
        <div className="product-list-card__footer product-list-card__footer--desktop">
          <a
            className="[ product-list-card__read-more ] [ text-medium color-grey-900 text-underline d-flex ]"
            href={product.url}
          >
            {translate('product-list-card.read-more')}
          </a>
        </div>
      </div>

      <div className="product-list-card__header product-list-card__header--mobile">
        <div className="product-list-card__image-wrapper product-list-card__image-wrapper--mobile">
          <ProductCardImage product={product} hideProductTags={true} />
        </div>
        <div className="product-list-card__mobile-right-section">
          {(product.hasConfigurator || product.otherProductTags.length > 0) && (
            <div style={{ marginBottom: '0.5rem' }}>
              {product.hasConfigurator && (
                <span className="product-tags__tag align-center">
                  {translate('product-image.custom-size')}
                </span>
              )}
              {product.otherProductTags.map((tag) => (
                <span key={product.id + tag} className="product-tags__tag">
                  {tag}
                </span>
              ))}
            </div>
          )}
          <div className="d-flex flex-column">
            <h3
              itemProp="name"
              className="[ product-list-card__title ] [ header-6 color-grey-900 ]"
            >
              {product.name}
            </h3>
            <span className="[ product-list-card__category ] [ text-small color-grey-500 text-uppercase ]">
              {product.category}
            </span>
          </div>
          {product.lowestPrice && (
            <div
              className={`[ variant-table__price ] [ d-flex flex-column text-medium bold ${
                product.lowestPrice.formattedCampaignPrice &&
                'product-list-card__from-price--has-campaign'
              } 
                   ${
                     product.price.formattedCampaignPrice
                       ? 'align-end'
                       : 'align-center'
                   } ]`}
            >
              {translate('product-list-card.from-price')}
              {product.price.formattedCampaignPrice
                ? product.lowestPrice.formattedCampaignPrice
                : product.lowestPrice.formattedPrice}
              {product.hasCampaignPrice && (
                <span>{product.lowestPrice.formattedPrice}</span>
              )}
            </div>
          )}
          <a
            className="text-small color-grey-900 text-underline"
            href={product.url}
          >
            {translate('product-list-card.read-more')}
          </a>
        </div>
      </div>
      {product.hasConfigurator ? (
        <a
          href={product.url}
          className="[ product-list-card__show-variants ] [ text-small text-uppercase color-black ]"
        >
          <label>{translate('product-card.choose-size-and-buy')}</label>
        </a>
      ) : (
        <Collapsible
          className="[ product-list-card__show-variants ] [ text-small text-uppercase color-black ]"
          transitionDuration="0.2s"
          openLabel={translate('product-card.show-variants')}
          closeLabel={translate('product-card.hide-variants')}
          showTogglerText={true}
        >
          {product.variants?.map((variant) => (
            <div
              className="product-list-card__mobile-variant"
              key={variant.articleNumber}
            >
              <div className="product-list-card__mobile-header [ d-flex justify-between ]">
                <div className="[ product-list-card__artnr-and-size ] [ d-flex flex-column justify-center ]">
                  <span className="[ product-list-card__art-nr ] [ text-small color-grey-500 lh-1 ]">
                    {translate('product-card.art-nr')} {variant.articleNumber}
                  </span>
                  <span className="[ product-list-card__size ] [ text-medium bold lh-1 ]">
                    {variant.variantName}
                  </span>
                </div>
                <div style={{ textTransform: 'none' }}>
                  <StockStatusTag
                    stockStatusType={variant.stockStatusType}
                    description={variant.stockStatusDescription}
                  />
                </div>
              </div>
              <div className="[ product-list-card__mobile-price-buybutton ] [ d-flex ]">
                <div
                  className={`[ product-list-card__from-price ${
                    variant.price.formattedCampaignPrice &&
                    'product-list-card__from-price--has-campaign'
                  } ] [ d-flex justify-center ]`}
                >
                  {variant.price.formattedCampaignPrice
                    ? variant.price.formattedCampaignPrice
                    : variant.price.formattedPrice}
                  {variant.price.formattedCampaignPrice && (
                    <span>{variant.price.formattedPrice}</span>
                  )}
                </div>
                <QuantityBuyButton
                  selectedVariantArtNumber={variant.articleNumber}
                />
              </div>
            </div>
          ))}
        </Collapsible>
      )}
    </div>
  );
};
export default ProductListViewCard;
